import { featuredArticles } from "@/mocks/home";

export default function FeaturedArticles() {
  return (
    <section id="featured" className="w-full bg-background-100 border-y border-background-200 scroll-mt-20">
      <div className="max-w-content mx-auto w-full px-4 md:px-8 py-14 md:py-20">
        <div className="mb-8 md:mb-10">
          <span className="text-xs md:text-sm font-medium text-primary-600 tracking-wide">
            FEATURED / 精选解读
          </span>
          <h2 className="mt-2 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            看懂热点背后的门道
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {featuredArticles.map((a) => (
            <article
              key={a.id}
              className="group flex flex-col sm:flex-row rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-primary-300 transition-colors"
            >
              <div className="w-full sm:w-44 h-44 sm:h-auto shrink-0 overflow-hidden">
                <img
                  src={a.cover}
                  alt={`${a.title}配图`}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-5 flex flex-col flex-1">
                <div className="flex items-center gap-2 text-xs">
                  <span className="px-2 py-0.5 rounded-md bg-accent-100 text-accent-900">{a.category}</span>
                  <span className="text-foreground-500">{a.date}</span>
                </div>
                <h3 className="mt-3 font-heading text-base md:text-lg font-bold text-foreground-950 leading-snug group-hover:text-primary-600 transition-colors">
                  {a.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-2 flex-1">
                  {a.excerpt}
                </p>
                <div className="mt-4 flex items-center justify-between text-xs text-foreground-500">
                  <span className="inline-flex items-center gap-1.5">
                    <i className="ri-user-3-line"></i>
                    {a.author}
                  </span>
                  <span className="inline-flex items-center gap-1.5">
                    <i className="ri-timer-line"></i>
                    阅读约 {a.readTime}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}